import { route_prefix } from "configs";

export const routeConstants = {
	root: {
		route: `${route_prefix}/`,
		name: "Home",
	},
	externalIncoming: {
		route: `${route_prefix}/external-incoming`,
		name: "External Incoming",
	},
	externalSending: {
		route: `${route_prefix}/external-sending`,
		name: "External Sending",
	},
	internalIncoming: {
		route: `${route_prefix}/internal-incoming`,
		name: "Internal Incoming",
	},
	internalSending: {
		route: `${route_prefix}/internal-sending`,
		name: "Internal Sending",
	},
	commandments: {
		route: `${route_prefix}/commandments`,
		name: "Commandments",
	},
	myCommandments: {
		route: `${route_prefix}/my-commandments`,
		name: "My commandments",
	},
	archieve: {
		route: `${route_prefix}/archieve`,
		name: "Archieve",
	},
	documentArchiveClosedIncoming: {
		route: `${route_prefix}/document-archive-closed-incoming`,
		name: "Document Archive Closed Incoming",
	},
	documentArchiveSendingExternal: {
		route: `${route_prefix}/document-archive-sending-external`,
		name: "Document Archive Sending External",
	},
	documentArchiveClosedSending: {
		route: `${route_prefix}/document-archive-closed-sending`,
		name: "Document Archive Closed Sending",
	},
	report: {
		route: `${route_prefix}/report`,
		name: "Report",
	},
	seeDocument: {
		route: `${route_prefix}/see-document`,
		name: "See Document",
	},
	chat: {
		route: `${route_prefix}/chat`,
		name: "Chat",
	},
	advancedFilter: {
		route: `${route_prefix}/advanced-filter`,
		name: "Advanced Filter",
	},
	contextSearch: {
		route: `${route_prefix}/context-search`,
		name: "Context search",
	},
	allLetters: {
		route: `${route_prefix}/all-letters`,
		name: "All letters",
	},
	betweenCompany: {
		route: `${route_prefix}/between-company`,
		name: "Between Company",
	},

	account: {
		route: `${route_prefix}/account`,
		name: "Account",
	},
	profile: {
		route: `${route_prefix}/profile`,
		name: "Profile",
	},
	contact: {
		route: `${route_prefix}/contact-us`,
		name: "Contact us",
	},
	login: {
		route: `${route_prefix}/login`,
		name: "Login",
	},
	register: {
		route: `${route_prefix}/register`,
		name: "Register",
	},
	forgetPassword: {
		route: `${route_prefix}/forget-password`,
		name: "Forget Password",
	},
	logout: {
		route: `${route_prefix}/logout`,
		name: "Logout",
	},
};
